var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7 4.4 12.32.81a4.68 4.68 0 0 0-3.62.5 4.74 4.74 0 0 0-2 2.38 4.73 4.73 0 0 0-5.32 4.68v15.18a4.72 4.72 0 0 0 3.5 4.55l13.38 3.59a4.7 4.7 0 0 0 4.09-.82 4.57 4.57 0 0 0 1.53-2.06c.203.015.407.015.61 0a4.72 4.72 0 0 0 4.7-4.72V8.95A4.72 4.72 0 0 0 25.7 4.4ZM23 27.13a3.512 3.512 0 0 1-4.42 3.4L5.19 26.94a3.51 3.51 0 0 1-2.61-3.39V8.37a3.53 3.53 0 0 1 3.51-3.52c.307.002.613.042.91.12l13.39 3.59A3.51 3.51 0 0 1 23 11.95v15.18Zm5-3a3.501 3.501 0 0 1-1.37 2.79c-.7.54-1.58.79-2.46.7.01-.163.01-.326 0-.49V11.95A4.72 4.72 0 0 0 20.7 7.4L7.88 3.96c.3-.673.8-1.238 1.43-1.62A3.54 3.54 0 0 1 12 1.97l13.39 3.59A3.51 3.51 0 0 1 28 8.95v15.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.72 26.77-10.53-2.83a3.51 3.51 0 0 1-2.61-3.39V7.04a.6.6 0 1 0-1.2 0v13.51a4.72 4.72 0 0 0 3.5 4.55l10.53 2.82a.41.41 0 0 0 .16 0 .62.62 0 0 0 .58-.45.6.6 0 0 0-.43-.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .25)",
    d: "M0 0h32v32H0z"
  })))));
};

export default SvgCopy;